// JS PDF
import jsPDF from "jspdf";
import autoTable, { type Styles } from "jspdf-autotable";

export interface TableConfig {
  margin?: number;
  paymentQrCode?: string | null;
  paymentLink?: string | null;
  headerFillColor: string;
  headerTextColor: string;
  stripeFillColor: string;
  stripeTextColor: string;
  body?: {
    [key: string]: string | number | null;
  }[];
  columns?: {
    header: string;
    dataKey: string;
  }[];
  columnStyles?: { [key: string]: Partial<Styles> };
  bodyStyles?: Partial<Styles>;
  headStyles?: Partial<Styles>;
  startY?: number;
}

const tableOutput = (doc: jsPDF, config: TableConfig) => {
  const margin = config.margin || 10;

  let startY = doc?.mainHeaderHeight;
  let top = doc?.runningHeaderHeight;
  let bottom = doc?.mainFooterPosition || margin;

  autoTable(doc, {
    body: config.body,
    columns: config.columns,
    startY: startY,
    theme: "striped",
    margin: { left: margin, right: margin, top: top, bottom: bottom },
    headStyles: {
      fillColor: config.headerFillColor,
      textColor: config.headerTextColor,
      fontSize: 8,
      lineWidth: 0,
      font: "Inter",
      fontStyle: "bold",
      cellPadding: { top: 2, bottom: 2, left: 2, right: 2 },
      overflow: "linebreak",
      ...config.headStyles,
    },
    bodyStyles: {
      textColor: "#000000",
      fontSize: 12,
      lineWidth: 0,
      font: "Inter",
      fontStyle: "normal",
      cellPadding: { top: 1.5, bottom: 1.5, left: 2, right: 2 },
      ...config.bodyStyles,
    },
    footStyles: {
      textColor: "#000000",
      fontSize: 9,
      font: "Inter",
      fontStyle: "bold",
      cellPadding: { top: 3, bottom: 3, left: 2, right: 2 },
    },
    columnStyles: {
      sellerName: {
        minCellWidth: 35,
      },
      buyerName: {
        minCellWidth: 35,
      },
      lotNumber: {
        minCellWidth: 20,
      },
      ...config.columnStyles,
    },
    didParseCell: (hookData) => {
      let isBody = hookData.section === "body";
      let cellValue = hookData.cell.raw;

      if (isBody) {
        // Check to see if we have a value for the cell
        if (cellValue === null || cellValue === undefined || cellValue === "") {
          hookData.cell.raw = "";
          hookData.cell.text = [""];
        }
      }
    },
  });

  // Lets push the lastY + 5
  doc.lastAutoTable.finalY += 5;
};

export default tableOutput;
